/**
 * Types for the tagging-parameter inventory: what variables/parameters
 * exist for tagging on a site (dataLayer pushes, GTM container variable
 * definitions, a live runtime snapshot when available), cross-referenced
 * against which tags actually consume them - see datalayer-inventory-utils.ts.
 */

export const DataLayerVariableSource = {
  /** A live window.dataLayer snapshot captured during a full-scan crawl. */
  LIVE_SNAPSHOT: 'live-snapshot',
  /** A literal dataLayer.push({...}) call decoded from static/DOM text. */
  DATALAYER_PUSH: 'datalayer-push',
  /** A GTM container's own "__v" Data Layer Variable definition. */
  GTM_CONTAINER: 'gtm-container'
} as const;
export type DataLayerVariableSourceType =
  (typeof DataLayerVariableSource)[keyof typeof DataLayerVariableSource];

export interface DataLayerVariableInventory {
  /** Sorted union of every discovered variable key/path. */
  available: string[];
  /** Sorted union of raw param keys already consumed by a decoded tag fire. */
  consumed: string[];
  /** available - consumed, sorted - a variable exists but nothing reads it. */
  unused: string[];
  /** Per-key provenance - which source(s) surfaced this variable. */
  sources: Record<string, DataLayerVariableSourceType[]>;
}
